import { MarketingEntryCtaButton } from "./marketing-entry-cta-button"

export function SetupTravelAssistantButton({
  variant,
  initialProvider,
  onClick,
}: {
  variant: "primary" | "knockout"
  initialProvider?: string
  onClick?: (action: "setup" | "get_started") => void
}) {
  return (
    <MarketingEntryCtaButton
      variant={variant}
      size="2xl"
      initialProvider={initialProvider}
      onClick={onClick}
    />
  )
}
